import { useEffect, useState } from "react";
import { Box, IconButton, Dialog, Typography } from "@mui/material";
import { Close, Mic, Save } from "@mui/icons-material";
import useRecorder from "../../utils/hooks/useRecorder";
import { formatMinutes, formatSeconds } from "../../utils";
import AudioPlayer from "../AudioPlayer";

const VoiceRecorder = ({ open, onClose, onSubmit }) => {
  const { recorderState, startRecording, saveRecording, cancelRecording } =
    useRecorder();
  const { recordingMinutes, recordingSeconds, initRecording, audioData } =
    recorderState;

  const [audioUrl, setAudioUrl] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showPlayer, setShowPlayer] = useState(false);

  useEffect(() => {
    if (!open) {
      handleReset();
    }
  }, [open]);

  useEffect(() => {
    if (audioData) {
      setAudioUrl(URL.createObjectURL(audioData));
      setShowPlayer(true);
    }
  }, [audioData]);

  const handleSave = () => {
    if (!audioData) {
      console.log("No audio recorded");
      return;
    }
    saveRecording();
    onSubmit(audioData);
    onClose();
  };

  const handleReset = () => {
    cancelRecording();
    setAudioUrl(null);
    setIsPlaying(false);
    setShowPlayer(false); // Hide the player
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "8px",
        },
      }}
    >
      <Box
        className="flex flex-col items-center p-4 gap-4 bg-white"
        sx={{
          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Record/Stop Button */}
        <IconButton
          className={`w-16 h-16 rounded-full ${
            initRecording
              ? "bg-red-500 text-white"
              : "bg-gray-300 text-gray-600"
          }`}
          onClick={initRecording ? handleReset : startRecording}
          sx={{
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
          }}
        >
          <Mic className="text-3xl" />
        </IconButton>

        {/* Timer */}
        <Typography variant="body2" color="textSecondary">
          {initRecording
            ? `${formatMinutes(recordingMinutes)}:${formatSeconds(
                recordingSeconds
              )}`
            : "Ready to record"}{" "}
        </Typography>

        {/* Audio Player (Conditional Rendering) */}
        {showPlayer &&
          audioUrl && ( // Conditionally render the player
            <AudioPlayer url={audioUrl} />
          )}

        {/* Save/Close Buttons */}
        <Box className="flex gap-2 mt-4">
          {" "}
          {/* Added margin top */}
          <IconButton
            className="text-gray-600"
            disabled={!audioData}
            onClick={handleSave}
            size="small"
          >
            <Save />
          </IconButton>
          <IconButton className="text-gray-600" onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default VoiceRecorder;
